<template>
  <div></div>
</template>

<script>
import { Toast } from 'vant'
import { getUserInfo, getWaterMarkTxt, getV8SsoInfo } from '@/api/wx.js'
import { checkUserIsActive, getUserSignOnInfo } from '@api/login.js'
import { removeWatermark, setWaterMark } from '@/utils/watermark'
export default {
  data() {
    return {}
  },
  mounted() {
    Toast.loading({
      message: '加载中...',
      forbidClick: true,
      duration: 0
    })
    localStorage.setItem('url', window.V3url + '/weixinlocal/index.html')
    sessionStorage.setItem('url', window.V3url + '/weixinlocal/index.html')
    this._getV8SsoInfo()
  },
  methods: {
    // 获取用户信息
    _getV8SsoInfo() {
      const queryObj = this.$route.query
      let queryStr = ``
      let encodeUrl = ''
      if (queryObj) {
        for (let key in queryObj) {
          if (key != 'guid') {
            queryStr += `${key}=${queryObj[key]}&`
          }
        }
        encodeUrl = encodeURIComponent(queryStr.slice(0, -1))
      }
      
      getUserSignOnInfo({
        guid: this.$route.query.guid,
        wf_paramlist: encodeUrl
      })
        .then(response => {
          console.log(response,'getUserSignOnInfogetUserSignOnInfo')
          localStorage.setItem('userid', response.data[0].userid)
          localStorage.setItem('userInfo', JSON.stringify(response.data[0]))
           Toast.clear()
          this.goto(queryStr.slice(0, -1))
        })
        .catch(error => {
          // this.$router.replace('/login')
          console.error(error, 'error')
        })
    },
    // 跳转
    goto(queryStr) {
      console.log(queryStr,'queryStrqueryStr')
      this.$router.push('/salaryReceipt?'+queryStr)
    }
  }
}
</script>

<style></style>
